/**
 * Identifies the message transaction type.
 * tag: 3020
 * @readonly
 * @enum {number} (int)
 */
export enum AlgoCertificateReportTransType {
  /** New */
  New = 0,
  /** Cancel */
  Cancel = 1,
  /** Replace */
  Replace = 2,
}
